import * as CONFIG from './config';


exports.getDecisionStatusLookups = function () {
    // console.log("getDecisionLookups==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpGet('/decision/decisionStatusLukp')
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.getDecision = function (id) {
    // console.log("getDecision==>", id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpGet('/decision/decisionById' + param)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.getDecisionList = function (id) {
    // console.log("getDecisionList==>", id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpGet('/decision/list' + param)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.addDecision = function (objModel) {
    // console.log("addDecision==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/decision/create', objModel)
            .then(function (response) {
                // console.log('addDecision succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('addDecision err==>',err);
                reject(err);
            });
    });
}

exports.updateDecision = function (objModel) {
    // console.log("updateDecision==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/decision/updateSubject', objModel)
            .then(function (response) {
                // console.log('updateDecision succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('updateDecision err==>',err);
                reject(err);
            });
    });
}

exports.updateSubDecision = function (objModel) {
    // console.log("updateSubDecision==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/decision/updateDecision', objModel)
            .then(function (response) {
                // console.log('updateSubDecision succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('updateSubDecision err==>',err);
                reject(err);
            });
    });
}

exports.deleteDecision = function (objModel) {
    // console.log("deleteDecision==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/decision/deleteSubject/'+ objModel)
            .then(function (response) {
                // console.log('deleteDecision succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('deleteDecision err==>',err);
                reject(err);
            });
    });
}

exports.deleteSubDecision = function (objModel) {
    // console.log("deleteSubDecision==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/decision/deleteDecision/'+objModel)
            .then(function (response) {
                // console.log('deleteSubDecision succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('deleteSubDecision err==>',err);
                reject(err);
            });
    });
}




// WEBPACK FOOTER //
// ./api/decisiondetails.js